import { isMobileLoginViewport, safeInternalNextPath } from '@/lib/loginPath';

/** 手机端独立后台路径前缀均为 /m/…（与 /m/login 同属 m 段） */

export const mobileAdmin = {
  dashboard: '/m/dashboard',
  register: '/m/register',
  entries: '/m/entries',
  users: '/m/users',
  analytics: '/m/analytics',
  analyticsFor: (id: number) => `/m/analytics/${id}`,
} as const;

/** 窄屏访问桌面路径时，重定向到对应手机页 */
export function desktopPathToMobile(pathname: string): string | null {
  const analyticsMatch = pathname.match(/^\/miniprograms\/(\d+)\/analytics\/?$/);
  if (analyticsMatch) {
    return mobileAdmin.analyticsFor(Number(analyticsMatch[1]));
  }
  const map: Record<string, string> = {
    '/dashboard': mobileAdmin.dashboard,
    '/entries': mobileAdmin.entries,
    '/users': mobileAdmin.users,
    '/sites': mobileAdmin.dashboard,
    '/help': mobileAdmin.dashboard,
  };
  return map[pathname] ?? null;
}

/** 非映射的桌面后台路径在窄屏下进入手机首页（顶部可切换站点） */
export function shouldRedirectUnmappedDesktopPath(pathname: string): boolean {
  if (pathname.startsWith('/m/')) return false;
  const desktop = [
    '/dashboard',
    '/entries',
    '/sites',
    '/users',
    '/log-center',
    '/login-logs',
    '/settings',
    '/wechat',
    '/interfaces',
    '/wechat-official-push',
    '/help',
  ];
  return desktop.includes(pathname);
}

/** 登录成功后的首页：窄屏进手机后台，宽屏进桌面后台 */
export function postLoginHomePath(): string {
  return isMobileLoginViewport() ? mobileAdmin.dashboard : '/dashboard';
}

/** 登录成功跳转：`next` 查询参数为站内路径时优先（与 Protected / 会话过期一致） */
export function resolvePostLoginTarget(searchParams: URLSearchParams): string {
  const n = safeInternalNextPath(searchParams.get('next'));
  if (n) {
    return n;
  }
  return postLoginHomePath();
}
